<template>
  <div class="stepper" :class="{horizontal}">
    <div
      v-for="(component,index) in components"
      :key="index"
      class="component-wrapper"
      :class="component.class"
    >
      <div class="component" :class="component.class">{{component.content}}</div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: ["context", "horizontal"],
  computed: {
    components() {
      const { totalSteps, currentStep } = this.context;
      const steps = Array(totalSteps)
        .fill({})
        .map((_, index) => ({
          index,
          content: index + 1,
          class: {
            step: true,
            completed: currentStep > index + 1,
            current: currentStep === index + 1
          }
        }));
      const lines = Array(totalSteps - 1)
        .fill({})
        .map((_, index) => ({
          index,
          content: "",
          class: {
            line: true,
            completed: currentStep > index + 1
          }
        }));
      const components = _.sortBy([...steps, ...lines], ["index"]);
      return components;
    }
  }
};
</script>

<style lang="scss" scoped>
.stepper {
  width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;

  .component-wrapper {
    .component {
      &.step {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #b7bcd2;
        color: #fdfdfd;
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
        text-align: center;

        &.completed {
          background-color: var(--v-primary-base);
        }

        &.current {
          width: 32px;
          height: 32px;
          line-height: 24px;
          background-color: var(--v-primary-base);
          border: 3px solid white;
          box-shadow: #40b9e5 0px 0px 0 2px;
        }
      }

      &.line {
        height: 100%;
        border-left: solid 3px rgba(183, 188, 210, 0.5);

        &.completed {
          border-left: dashed 3px #02b9e5;
        }
      }
    }

    &.step.current {
      border-radius: 50%;
      box-shadow: 0 0 7px 0 rgba(2, 185, 229, 0.4),
        0 0 15px 0 rgba(2, 185, 229, 0.25);
    }

    &.line {
      flex-grow: 1;
    }
  }

  // HORIZONTAL
  &.horizontal {
    flex-direction: row;

    .component.line {
      border-bottom: solid 3px rgba(183, 188, 210, 0.5);
      &.completed {
        border-bottom: dashed 3px #02b9e5;
      }
    }
  }
}
</style>